import { cx } from '../../../design-system/components/cx';

interface PricingToggleProps {
  isYearly: boolean;
  onToggle: () => void;
}

/** Monthly / Yearly billing switch. "Save 17%" shows with Yearly on. */
export default function PricingToggle({ isYearly, onToggle }: PricingToggleProps) {
  return (
    <div className="ee-landing-toggle">
      <span className={cx('ee-landing-toggle__label', !isYearly && 'ee-landing-toggle__label--on')}>
        Monthly
      </span>
      <button
        type="button"
        onClick={onToggle}
        role="switch"
        aria-checked={isYearly}
        className="ee-landing-toggle__switch"
        aria-label={`Switch to ${isYearly ? 'monthly' : 'yearly'} billing`}
      >
        <span className="ee-landing-toggle__knob" />
      </button>
      <span className={cx('ee-landing-toggle__label', isYearly && 'ee-landing-toggle__label--on')}>
        Yearly
      </span>
      <span className={cx('ee-landing-toggle__save', isYearly && 'ee-landing-toggle__save--on')}>
        Save 17%
      </span>
    </div>
  );
}
